import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 15000,
});

// ---------- AUTH ----------
export const login = (username, pin) => api.post("/auth/login", { username, pin }).then((r) => r.data);
export const listUsers = () => api.get("/auth/users").then((r) => r.data);

// ---------- CATALOG ----------
export const listCategories = () => api.get("/categories").then((r) => r.data);
export const listProducts = (params = {}) => api.get("/products", { params }).then((r) => r.data);
export const findByBarcode = (barcode) => api.get("/products", { params: { barcode } }).then((r) => r.data);

// ---------- CUSTOMERS ----------
export const listCustomers = (q) => api.get("/customers", { params: q ? { q } : {} }).then((r) => r.data);
export const createCustomer = (data) => api.post("/customers", data).then((r) => r.data);

// ---------- CASH ----------
export const currentSession = (userId) => api.get("/cash/current", { params: { user_id: userId } }).then((r) => r.data);
export const openCash = (req, user) =>
  api.post("/cash/open", req, { params: { user_id: user.id, user_name: user.name } }).then((r) => r.data);
export const closeCash = (req, sessionId) =>
  api.post("/cash/close", req, { params: { session_id: sessionId } }).then((r) => r.data);
export const addMovement = (req, sessionId, userId) =>
  api.post("/cash/movement", req, { params: { session_id: sessionId, user_id: userId } }).then((r) => r.data);
export const sessionSummary = (sessionId) => api.get(`/cash/${sessionId}/summary`).then((r) => r.data);
export const xReport = (sessionId) => api.get(`/cash/${sessionId}/x-report`).then((r) => r.data);

// ---------- SALES ----------
export const startSale = (req, user, sessionId) =>
  api
    .post("/sales", req, { params: { user_id: user.id, user_name: user.name, session_id: sessionId } })
    .then((r) => r.data);
export const listSales = (params = {}) => api.get("/sales", { params }).then((r) => r.data);
export const getSale = (id) => api.get(`/sales/${id}`).then((r) => r.data);
export const addLine = (saleId, body) => api.post(`/sales/${saleId}/lines`, body).then((r) => r.data);
export const updateLine = (saleId, lineId, body) =>
  api.patch(`/sales/${saleId}/lines/${lineId}`, body).then((r) => r.data);
export const removeLine = (saleId, lineId) => api.delete(`/sales/${saleId}/lines/${lineId}`).then((r) => r.data);
export const parkSale = (id) => api.post(`/sales/${id}/park`).then((r) => r.data);
export const resumeSale = (id) => api.post(`/sales/${id}/resume`).then((r) => r.data);
export const cancelSale = (id) => api.post(`/sales/${id}/cancel`).then((r) => r.data);
export const checkout = (id, body) => api.post(`/sales/${id}/checkout`, body).then((r) => r.data);
export const refundSale = (id, body, user, sessionId) =>
  api
    .post(`/sales/${id}/refund`, body, { params: { user_id: user.id, user_name: user.name, session_id: sessionId } })
    .then((r) => r.data);

// Header / cliente / entregas a cuenta (Sage flow)
export const updateHeader = (saleId, body) => api.patch(`/sales/${saleId}/header`, body).then((r) => r.data);
export const setCustomer = (saleId, customerId) =>
  api.patch(`/sales/${saleId}/customer`, null, { params: customerId ? { customer_id: customerId } : {} }).then((r) => r.data);
export const addAdvance = (saleId, body) => api.post(`/sales/${saleId}/advance`, body).then((r) => r.data);
export const removeAdvance = (saleId, advanceId) =>
  api.delete(`/sales/${saleId}/advance/${advanceId}`).then((r) => r.data);

// Settings
export const getSettings = () => api.get("/settings").then((r) => r.data);
export const updateSettings = (body) => api.patch("/settings", body).then((r) => r.data);

// ---------- SAGE / VERIFACTU ----------
export const sageStatus = () => api.get("/sage/status").then((r) => r.data);
export const sageToggle = () => api.post("/sage/toggle").then((r) => r.data);
export const sageResync = () => api.post("/sage/resync").then((r) => r.data);
export const verifactuChain = () => api.get("/verifactu/chain").then((r) => r.data);

// ---------- REPORTS ----------
export const dashboardReport = () => api.get("/reports/dashboard").then((r) => r.data);
